import LoginView from '@/views/login/login-view.vue'
import AuthService from '@/services/auth.service'

export default [
  {
    path: '/',
    name: 'Login',
    component: LoginView,
    meta: {
      title: 'Bienvenido',
      access: ['*']
    },
    beforeEnter (to, from, next) {
      AuthService.isAuthenticated() ? next(AuthService.redirectURL) : next()
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/login/index.js